var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"dataTable":_vm.walletList},on:{"showModal":function (ref$1){
	var ref = ref$1.ref;
	var walletId = ref$1.walletId;

	return _vm.showCommentsModal(ref, walletId);
}}}),_c('ShowMoreButton',{on:{"click":_vm.nextPage}}),_c('CommentsModal',{attrs:{"open":_vm.modalOpened,"reference":_vm.reference,"wallet":_vm.wallet},on:{"closeModal":function($event){return _vm.closeCommentsModal()},"showSuccessModal":_vm.showCommentsSuccessModal}}),_c('CommentsSuccessModal',{attrs:{"open":_vm.modalSuccessOpened},on:{"closeModal":function($event){return _vm.closeCommentsSuccessModal()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }